<template>
  <div class="component-detail-status">
    <div class="device-data" v-if="statusList.length">
      <div class="device-param-detail" v-for="(item, index) in statusList" :key="index">
        <div class="title">{{ item.dataName }}</div>
        <div class="value" :title="getDicVal(item)">
          {{ getDicVal(item) || '-' }}
        </div>
      </div>
      <i class="device-param-detail empty"></i>
      <i class="device-param-detail empty"></i>
    </div>
    <div class="device-data" v-if="!statusList.length">
      <p class="no-data">{{ $t('Common.com_no_data') }}</p>
    </div>
    <div class="chart-content" v-if="showChart">
      <div class="chart-el" ref="chart"></div>
      <custom-date-picker
        :init-value="initDate"
        v-model="date"
        class="date-picker"
        :clearable="false"
        value-format="YYYY-MM-DD HH:mm:ss"
        @init="getChartData"
        @change="updateChart"
        :picker-options="pickerOptionDisAfter"
      ></custom-date-picker>
    </div>
  </div>
</template>

<script>
import G2 from 'G2';
import DataSet from '@antv/data-set';
import apis from '@/utils/apis.js';
// import mockData from './detailStatusChartMockData';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {};
      },
    },
    showChart: Boolean,
  },
  data() {
    return {
      chart: null,
      status: [],
      data: [],
      faultData: {},
      fileList: [],
      showUnit: '',
      date: new Date(),
      initDate: '',
    };
  },
  computed: {
    statusList() {
      return this.status.filter((obj) => obj.dataValue && obj.dataValue !== 'null');
    },
  },
  methods: {
    getDicVal(item) {
      if (item.showUnit && item.showUnit.indexOf('℃') > -1) {
        return (this.$celsiusToFahrenheit(item.dataValue) || '') + (item.showUnit.replace('℃', this.$formatTempUnit()) || '');
      }
      if (item.dicGroup) {
        return this.getDicValue(item.dicGroup, item.dataValue) + (item.showUnit || '');
      }
      if (item.dataType === 'Date') {
        return this.$momentLocal(item.dataValue);
      }
      return (item.dataValue || '') + (item.showUnit || '');
    },
    getMaxNum(list, property) {
      let max = list[0][property];
      list.forEach((item) => {
        if (item[property] > max) {
          max = item[property];
        }
      });
      return max;
    },
    getChartData() {
      if (this.showChart) {
        return this.$getJSON(apis.modemBatteryComponentVoltage, {
          modemSn: this.model.modemSn,
          componentCode: this.model.componentCode,
          // startTime: `${moment(this.date).format('YYYY-MM-DD')} 00:00:00`,
          // endTime: `${moment(this.date).format('YYYY-MM-DD')} 23:59:59`
          startTime: this.$moment.utc(this.date).format('YYYY-MM-DD HH:mm:ss'),
          endTime: this.$moment.utc(this.date).add(1, 'd').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss'),
        }).then((res) => {
          this.data = res.data.voltageList || [];
          this.data.forEach((item) => {
            item.totalVolt = Number(item.totalVolt);
            item.recordTime = this.$momentLocal(item.recordTime);
          });
          this.showUnit = res.data.showUnit || 'A';
        });
      }
      return '';
    },
    updateChart() {
      this.getChartData().then(() => {
        //  this.chart.clear();

        // 清除图表guide
        this.chart.guide().clear();
        // 起始位置（左上角）
        this.chart.guide().text({
          top: true, // 指定 giude 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
          position: ['start', 'end'], // 文本的起始位置，值为原始数据值，支持 callback
          content: this.showUnit ? this.$t('components_component_detail_status.dian_liuo', [this.showUnit]) : this.$t('components_component_detail_status.dian_liuA'), // 显示的文本内容
          style: {
            // 文本的图形样式属性
            fill: '#495057', // 文本颜色
            fontSize: '12', // 文本大小
            fontWeight: 'bold',
          }, // 文本的图形样式属性
          offsetX: -35, // x 方向的偏移量
          offsetY: -30, // y 方向偏移量
        });
        this.chart.changeData(this.data);
      });
    },
    initChart() {
      const data = this.data;
      // const data = mockData;
      const ds = new DataSet();

      const dv = ds.createView('origin').source(data);

      dv.transform({
        type: 'map',
        callback: function callback(row) {
          const times = row.recordTime.split(' ');
          row.time = times[1];
          row.date = times[0];
          return row;
        },
      });

      const chart = new G2.Chart({
        container: this.$refs.chart,
        forceFit: true,
        height: 346,
        padding: [60, 51, 55, 54],
      });

      this.chart = chart;

      chart.source(dv, {
        recordTime: {
          type: 'cat',
          tickCount: 24,
        },
        totalVolt: {
          alias: this.$t('components_component_detail_status.shi_shi_dian_liu'),
        },
      });
      chart.axis('recordTime', {
        label: {
          formatter(val) {
            return val.split(' ')[1];
          },
        },
        formatter: function formatter(text) {
          return text.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        },
      });
      chart.axis('totalVolt', {
        label: {
          textStyle: {
            fill: '#aaaaaa',
          },
        },
        line: {
          lineWidth: 1,
          stroke: '#BFBFBF',
          length: 4,
          alignWithLabel: true,
        },
      });
      chart.legend(false);

      // 起始位置（左上角）
      chart.guide().text({
        top: true, // 指定 giude 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
        position: ['start', 'end'], // 文本的起始位置，值为原始数据值，支持 callback
        content: `${`电流${this.showUnit ? `(${this.showUnit})` : '(A)'}`}`, // 显示的文本内容
        style: {
          // 文本的图形样式属性
          fill: '#495057', // 文本颜色
          fontSize: '12', // 文本大小
          fontWeight: 'bold',
        }, // 文本的图形样式属性
        offsetX: -35, // x 方向的偏移量
        offsetY: -30, // y 方向偏移量
      });

      chart
        .line()
        .position('recordTime*totalVolt')
        .color('#1890ff')
        .tooltip('recordTime*totalVolt', (name, value) => ({
          name: this.$t('components_component_detail_status.shi_shi_dian_liu'),
          value: `${value + (this.showUnit ? `(${this.showUnit})` : '')}`,
        }));

      chart.render();
    },
    getStatus() {
      this.$getJSON(apis.modemBatteryComponentStatus, {
        modemSn: this.model.modemSn,
        componentCode: this.model.componentCode,
      }).then((res) => {
        this.status = res.data.map((item) => {
          item.dicValue = '';
          return item;
        });
      });
    },
  },
  mounted() {
    this.initDate = `${this.$moment().format('YYYY-MM-DD')} 00:00:00`;
    if (this.showChart) {
      this.updateChart();
    }
    this.getStatus();
  },
};
</script>

<style lang="scss">
.component-detail-status {
  padding-bottom: 50px;

  .device-data {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 16px;

    .device-param-detail {
      width: 185px;
      height: 67px;
      background: #f8f9fb;
      padding: 12px;
      margin-bottom: 4px;
      &.empty {
        background: none;
        width: 185px;
        height: 0;
        padding: 0;
      }
      .title {
        color: #495057;
        font-size: 12px;
        line-height: 17px;
      }
      .value {
        margin-top: 8px;
        font-size: 15px;
        line-height: 17px;
        color: #323336;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .no-data {
      padding: 12px;
      text-align: center;
      margin-top: 8px;
      font-size: 15px;
      width: 100%;
      line-height: 17px;
      color: #323336;
      font-weight: bold;
    }
  }
  .chart-content {
    margin-top: 15px;
    border: 1px solid #f2f3fb;
    position: relative;
    overflow: hidden;
    margin-bottom: 15px;

    .date-picker {
      position: absolute;
      z-index: 1000;
      top: 15px;
      right: 15px;
    }
  }
}
</style>
